var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{},[_c('input',{staticClass:"btn btn-danger",staticStyle:{"color":"white"},attrs:{"type":"submit","value":"Delete Product"},on:{"click":function($event){return _vm.deleteProduct($event)}}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }